import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  "aria-label": "breadcrumb",
  class: "mt-5 pt-5 ps-3"
}
const _hoisted_2 = { class: "breadcrumb mb-3" }
const _hoisted_3 = { class: "breadcrumb-item" }
const _hoisted_4 = { class: "breadcrumb-item" }
const _hoisted_5 = {
  class: "breadcrumb-item active",
  "aria-current": "page"
}
const _hoisted_6 = { class: "container-fluid" }
const _hoisted_7 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "row mb-4" }
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = { class: "card" }
const _hoisted_12 = { class: "card-body" }
const _hoisted_13 = { class: "row align-items-center" }
const _hoisted_14 = { class: "col-md-8" }
const _hoisted_15 = { class: "mb-2" }
const _hoisted_16 = { class: "text-muted mb-2" }
const _hoisted_17 = { class: "text-primary" }
const _hoisted_18 = { class: "mb-3" }
const _hoisted_19 = { class: "d-flex gap-3 flex-wrap" }
const _hoisted_20 = { class: "col-md-4 text-md-end" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col-12" }
const _hoisted_23 = { class: "card" }
const _hoisted_24 = { class: "card-header" }
const _hoisted_25 = {
  class: "nav nav-tabs card-header-tabs",
  role: "tablist"
}
const _hoisted_26 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_27 = {
  key: 0,
  class: "badge bg-primary ms-1"
}
const _hoisted_28 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_29 = { class: "card-body" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { class: "card bg-light mb-4" }
const _hoisted_32 = { class: "card-body" }
const _hoisted_33 = { class: "row" }
const _hoisted_34 = { class: "col-md-4 mb-3" }
const _hoisted_35 = {
  key: 0,
  class: "col-md-4 mb-3"
}
const _hoisted_36 = {
  key: 0,
  class: "list-group mt-2",
  style: {"max-height":"200px","overflow-y":"auto"}
}
const _hoisted_37 = ["onClick"]
const _hoisted_38 = {
  key: 1,
  class: "mt-2"
}
const _hoisted_39 = { class: "badge bg-info" }
const _hoisted_40 = {
  key: 1,
  class: "col-md-4 mb-3"
}
const _hoisted_41 = {
  for: "scopeId",
  class: "form-label text-black"
}
const _hoisted_42 = ["placeholder"]
const _hoisted_43 = { class: "col-md-4 mb-3 d-flex align-items-end" }
const _hoisted_44 = ["disabled"]
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { key: 1 }
const _hoisted_47 = {
  key: 0,
  class: "text-center py-4"
}
const _hoisted_48 = {
  key: 1,
  class: "text-center py-4"
}
const _hoisted_49 = {
  key: 2,
  class: "table-responsive"
}
const _hoisted_50 = { class: "table table-hover" }
const _hoisted_51 = { key: 0 }
const _hoisted_52 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_53 = { class: "text-end" }
const _hoisted_54 = ["onClick"]
const _hoisted_55 = { key: 1 }
const _hoisted_56 = { class: "row" }
const _hoisted_57 = { class: "col-12" }
const _hoisted_58 = {
  key: 0,
  class: "text-center py-5 text-muted"
}
const _hoisted_59 = { class: "message-header" }
const _hoisted_60 = { class: "text-muted ms-2" }
const _hoisted_61 = { class: "message-content" }
const _hoisted_62 = {
  key: 1,
  class: "chat-message agent-message"
}
const _hoisted_63 = { class: "message-header" }
const _hoisted_64 = { class: "input-group" }
const _hoisted_65 = ["disabled"]
const _hoisted_66 = ["disabled"]
const _hoisted_67 = ["disabled"]
const _hoisted_68 = {
  key: 2,
  class: "text-center py-5"
}
const _hoisted_69 = { class: "modal-dialog" }
const _hoisted_70 = { class: "modal-content" }
const _hoisted_71 = { class: "modal-body" }
const _hoisted_72 = { class: "text-muted" }
const _hoisted_73 = { class: "modal-footer" }
const _hoisted_74 = ["disabled"]
const _hoisted_75 = { key: 0 }
const _hoisted_76 = { key: 1 }

import { ref, reactive, computed, onMounted, nextTick } from "vue";
import { useRouter, useRoute } from "vue-router";
import apiService from "@/services/apiService";
import { Modal } from "bootstrap";

// Router

export default /*@__PURE__*/_defineComponent({
  __name: 'AgentDetails',
  setup(__props) {

const router = useRouter();
const route = useRoute();

// Computed
const agentId = computed(() => route.params.id as string);

// Data
const agent = ref<any>(null);
const isLoading = ref(false);
const activeTab = ref("assignments");

// Assignments
const assignments = ref<any[]>([]);
const isLoadingAssignments = ref(false);
const isAddingAssignment = ref(false);
const assignmentForm = reactive({
  scopeType: "",
  scopeId: "",
  selectedUser: null as any,
});

// User search
const userSearchQuery = ref("");
const userSearchResults = ref<any[]>([]);
const userSearchTimeout = ref<any>(null);

// Delete assignment
const assignmentToDelete = ref<any>(null);
const deleteAssignmentModalRef = ref<HTMLElement | null>(null);
const isDeletingAssignment = ref(false);

// Chat
const chatMessages = ref<any[]>([]);
const chatInput = ref("");
const isSendingMessage = ref(false);
const chatContainerRef = ref<HTMLElement | null>(null);

// Methods
const loadAgent = async () => {
  isLoading.value = true;
  try {
    const response = await apiService.getAgentById(agentId.value);
    agent.value = response;
  } catch (err: any) {
    console.error("Error loading agent:", err);
    showToast(err?.response?.data?.message || "Failed to load agent", "error");
  } finally {
    isLoading.value = false;
  }
};

const loadAssignments = async () => {
  isLoadingAssignments.value = true;
  try {
    const response = await apiService.getAgentAssignments(agentId.value);
    assignments.value = response.data || response.assignments || [];
  } catch (err: any) {
    console.error("Error loading assignments:", err);
    showToast(
      err?.response?.data?.message || "Failed to load assignments",
      "error"
    );
  } finally {
    isLoadingAssignments.value = false;
  }
};

const handleUserSearch = () => {
  if (userSearchTimeout.value) {
    clearTimeout(userSearchTimeout.value);
  }

  userSearchTimeout.value = setTimeout(async () => {
    if (userSearchQuery.value.trim().length < 2) {
      userSearchResults.value = [];
      return;
    }

    try {
      const response = await apiService.searchUsers(userSearchQuery.value);
      userSearchResults.value = response.data || response.users || [];
    } catch (err: any) {
      console.error("Error searching users:", err);
      userSearchResults.value = [];
    }
  }, 300);
};

const selectUser = (user: any) => {
  assignmentForm.selectedUser = user;
  assignmentForm.scopeId = user._id || user.id;
  userSearchQuery.value = user.name;
  userSearchResults.value = [];
};

const handleAddAssignment = async () => {
  if (!assignmentForm.scopeType) {
    showToast("Please select a scope type", "error");
    return;
  }

  if (assignmentForm.scopeType === "USER" && !assignmentForm.selectedUser) {
    showToast("Please select a user", "error");
    return;
  }

  if (assignmentForm.scopeType !== "USER" && !assignmentForm.scopeId.trim()) {
    showToast("Please enter a scope ID", "error");
    return;
  }

  isAddingAssignment.value = true;
  try {
    const payload = {
      scopeType: assignmentForm.scopeType,
      scopeId:
        assignmentForm.scopeType === "USER"
          ? assignmentForm.selectedUser._id || assignmentForm.selectedUser.id
          : assignmentForm.scopeId.trim(),
    };

    await apiService.createAgentAssignment(agentId.value, payload);
    showToast("Assignment added successfully", "success");

    // Reset form
    assignmentForm.scopeType = "";
    assignmentForm.scopeId = "";
    assignmentForm.selectedUser = null;
    userSearchQuery.value = "";
    userSearchResults.value = [];

    // Reload assignments
    loadAssignments();
  } catch (err: any) {
    console.error("Error adding assignment:", err);
    showToast(
      err?.response?.data?.message || "Failed to add assignment",
      "error"
    );
  } finally {
    isAddingAssignment.value = false;
  }
};

const confirmDeleteAssignment = (assignment: any) => {
  assignmentToDelete.value = assignment;
  const modalElement = deleteAssignmentModalRef.value;
  if (modalElement) {
    const modal = new Modal(modalElement);
    modal.show();
  }
};

const deleteAssignment = async () => {
  if (!assignmentToDelete.value) return;

  isDeletingAssignment.value = true;
  try {
    await apiService.deleteAgentAssignment(
      agentId.value,
      assignmentToDelete.value._id || assignmentToDelete.value.id
    );
    showToast("Assignment deleted successfully", "success");

    // Close modal
    const modalElement = deleteAssignmentModalRef.value;
    if (modalElement) {
      const modal = Modal.getInstance(modalElement);
      if (modal) {
        modal.hide();
      }
    }

    assignmentToDelete.value = null;
    loadAssignments();
  } catch (err: any) {
    console.error("Error deleting assignment:", err);
    showToast(
      err?.response?.data?.message || "Failed to delete assignment",
      "error"
    );
  } finally {
    isDeletingAssignment.value = false;
  }
};

const handleSendMessage = async () => {
  if (!chatInput.value.trim()) return;

  const userMessage = {
    role: "user",
    content: chatInput.value.trim(),
    timestamp: new Date(),
  };

  chatMessages.value.push(userMessage);
  const currentInput = chatInput.value;
  chatInput.value = "";

  // Scroll to bottom
  await nextTick();
  scrollToBottom();

  isSendingMessage.value = true;
  try {
    const response = await apiService.testAgentChat(
      agentId.value,
      currentInput,
      chatMessages.value
    );

    console.log("Chat response:", response);

    // Handle different response structures
    const assistantContent =
      response.data?.assistantMessage ||
      response.assistantMessage ||
      response.message ||
      response.response ||
      "No response";

    const agentMessage = {
      role: "agent",
      content: assistantContent,
      timestamp: new Date(),
    };

    chatMessages.value.push(agentMessage);

    await nextTick();
    scrollToBottom();
  } catch (err: any) {
    console.error("Error sending message:", err);
    showToast(
      err?.response?.data?.message || "Failed to send message",
      "error"
    );

    // Add error message
    chatMessages.value.push({
      role: "agent",
      content: "Sorry, I encountered an error processing your message.",
      timestamp: new Date(),
    });
  } finally {
    isSendingMessage.value = false;
  }
};

const clearChat = () => {
  if (confirm("Are you sure you want to clear the chat history?")) {
    chatMessages.value = [];
  }
};

const scrollToBottom = () => {
  if (chatContainerRef.value) {
    chatContainerRef.value.scrollTop = chatContainerRef.value.scrollHeight;
  }
};

const getScopeTypeBadgeClass = (scopeType: string): string => {
  switch (scopeType) {
    case "MODULE":
      return "bg-primary";
    case "ROLE":
      return "bg-success";
    case "USER":
      return "bg-info";
    default:
      return "bg-secondary";
  }
};

const getToolsCount = (tools: any): number => {
  if (!tools) return 0;
  if (Array.isArray(tools)) return tools.length;
  return 0;
};

const getKnowledgeBasesCount = (kbIds: any): number => {
  if (!kbIds) return 0;
  if (Array.isArray(kbIds)) return kbIds.length;
  return 0;
};

const formatDate = (dateString: string): string => {
  if (!dateString) return "N/A";
  const date = new Date(dateString);
  return date.toLocaleDateString();
};

const formatTime = (timestamp: Date): string => {
  return timestamp.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });
};

const showToast = (message: string, type: "success" | "error" | "info") => {
  console.log(`[${type.toUpperCase()}] ${message}`);
  // Integrate with your toast library here
};

// Lifecycle
onMounted(() => {
  loadAgent();
  loadAssignments();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("ol", _hoisted_2, [
        _createElementVNode("li", _hoisted_3, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode("Home", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_4, [
          _createVNode(_component_router_link, { to: "/admin/agents" }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createTextVNode("Agents", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_5, _toDisplayString(agent.value?.name || "Details"), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[8] || (_cache[8] = [
            _createElementVNode("div", {
              class: "spinner-border text-primary",
              role: "status"
            }, [
              _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
            ], -1),
            _createElementVNode("p", { class: "mt-2" }, "Loading agent details...", -1)
          ]))]))
        : (agent.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("h4", _hoisted_15, [
                            _createTextVNode(_toDisplayString(agent.value.name) + " ", 1),
                            _createElementVNode("span", {
                              class: _normalizeClass([
                          'badge',
                          'ms-2',
                          agent.value.is_active ?? agent.value.isActive
                            ? 'bg-success'
                            : 'bg-secondary',
                        ])
                            }, _toDisplayString(agent.value.is_active ?? agent.value.isActive
                            ? "Active"
                            : "Inactive"), 3)
                          ]),
                          _createElementVNode("p", _hoisted_16, [
                            _createElementVNode("code", _hoisted_17, _toDisplayString(agent.value.slug), 1)
                          ]),
                          _createElementVNode("p", _hoisted_18, _toDisplayString(agent.value.description), 1),
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("span", null, [
                              _cache[9] || (_cache[9] = _createElementVNode("i", { class: "fa fa-microchip me-1 text-primary" }, null, -1)),
                              _cache[10] || (_cache[10] = _createElementVNode("strong", null, "Model:", -1)),
                              _createTextVNode(" " + _toDisplayString(agent.value.model), 1)
                            ]),
                            _createElementVNode("span", null, [
                              _cache[11] || (_cache[11] = _createElementVNode("i", { class: "fa fa-thermometer-half me-1 text-warning" }, null, -1)),
                              _cache[12] || (_cache[12] = _createElementVNode("strong", null, "Temperature:", -1)),
                              _createTextVNode(" " + _toDisplayString(agent.value.temperature), 1)
                            ]),
                            _createElementVNode("span", null, [
                              _cache[13] || (_cache[13] = _createElementVNode("i", { class: "fa fa-coins me-1 text-info" }, null, -1)),
                              _cache[14] || (_cache[14] = _createElementVNode("strong", null, "Max Tokens:", -1)),
                              _createTextVNode(" " + _toDisplayString(agent.value.max_output_tokens || agent.value.maxOutputTokens), 1)
                            ]),
                            _createElementVNode("span", null, [
                              _cache[15] || (_cache[15] = _createElementVNode("i", { class: "fa fa-wrench me-1 text-success" }, null, -1)),
                              _cache[16] || (_cache[16] = _createElementVNode("strong", null, "Tools:", -1)),
                              _createTextVNode(" " + _toDisplayString(getToolsCount(
                            agent.value.tools_allowed || agent.value.toolsAllowed
                          )), 1)
                            ]),
                            _createElementVNode("span", null, [
                              _cache[17] || (_cache[17] = _createElementVNode("i", { class: "fa fa-database me-1 text-warning" }, null, -1)),
                              _cache[18] || (_cache[18] = _createElementVNode("strong", null, "Knowledge Bases:", -1)),
                              _createTextVNode(" " + _toDisplayString(getKnowledgeBasesCount(
                            agent.value.knowledge_base_ids || agent.value.knowledgeBaseIds
                          )), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _createVNode(_component_router_link, {
                            to: `/admin/agents/${agentId.value}/edit`,
                            class: "btn btn-primary btn-sm mb-2"
                          }, {
                            default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                              _createElementVNode("i", { class: "fa fa-edit me-1" }, null, -1),
                              _createTextVNode(" Edit Agent ", -1)
                            ]))]),
                            _: 1
                          }, 8, ["to"]),
                          _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1)),
                          _createVNode(_component_router_link, {
                            to: "/admin/agents",
                            class: "btn btn-outline-secondary btn-sm"
                          }, {
                            default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                              _createElementVNode("i", { class: "fa fa-arrow-left me-1" }, null, -1),
                              _createTextVNode(" Back to List ", -1)
                            ]))]),
                            _: 1
                          })
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("ul", _hoisted_25, [
                        _createElementVNode("li", _hoisted_26, [
                          _createElementVNode("button", {
                            class: _normalizeClass(["nav-link", { active: activeTab.value === 'assignments' }]),
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (activeTab.value = 'assignments')),
                            type: "button"
                          }, [
                            _cache[22] || (_cache[22] = _createElementVNode("i", { class: "fa fa-users me-1" }, null, -1)),
                            _cache[23] || (_cache[23] = _createTextVNode(" Assignments ", -1)),
                            (assignments.value.length > 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(assignments.value.length), 1))
                              : _createCommentVNode("", true)
                          ], 2)
                        ]),
                        _createElementVNode("li", _hoisted_28, [
                          _createElementVNode("button", {
                            class: _normalizeClass(["nav-link", { active: activeTab.value === 'test-chat' }]),
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (activeTab.value = 'test-chat')),
                            type: "button"
                          }, [...(_cache[24] || (_cache[24] = [
                            _createElementVNode("i", { class: "fa fa-comment me-1" }, null, -1),
                            _createTextVNode(" Preview / Test Chat ", -1)
                          ]))], 2)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      (activeTab.value === 'assignments')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                              _createElementVNode("div", _hoisted_32, [
                                _cache[31] || (_cache[31] = _createElementVNode("h6", { class: "mb-3" }, [
                                  _createElementVNode("i", { class: "fa fa-plus-circle me-2" }),
                                  _createTextVNode("Add Assignment ")
                                ], -1)),
                                _createElementVNode("form", {
                                  onSubmit: _withModifiers(handleAddAssignment, ["prevent"])
                                }, [
                                  _createElementVNode("div", _hoisted_33, [
                                    _createElementVNode("div", _hoisted_34, [
                                      _cache[26] || (_cache[26] = _createElementVNode("label", {
                                        for: "scopeType",
                                        class: "form-label text-black"
                                      }, [
                                        _createTextVNode(" Scope Type "),
                                        _createElementVNode("span", { class: "text-danger" }, "*")
                                      ], -1)),
                                      _withDirectives(_createElementVNode("select", {
                                        class: "form-select",
                                        id: "scopeType",
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((assignmentForm.scopeType) = $event)),
                                        required: ""
                                      }, [...(_cache[25] || (_cache[25] = [
                                        _createElementVNode("option", { value: "" }, "Select Type", -1),
                                        _createElementVNode("option", { value: "MODULE" }, "Module", -1),
                                        _createElementVNode("option", { value: "ROLE" }, "Role", -1),
                                        _createElementVNode("option", { value: "USER" }, "User", -1)
                                      ]))], 512), [
                                        [_vModelSelect, assignmentForm.scopeType]
                                      ])
                                    ]),
                                    (assignmentForm.scopeType === 'USER')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                          _cache[27] || (_cache[27] = _createElementVNode("label", {
                                            for: "userSearch",
                                            class: "form-label text-black"
                                          }, [
                                            _createTextVNode(" Search User "),
                                            _createElementVNode("span", { class: "text-danger" }, "*")
                                          ], -1)),
                                          _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control",
                                            id: "userSearch",
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((userSearchQuery).value = $event)),
                                            onInput: handleUserSearch,
                                            placeholder: "Search by name or email..."
                                          }, null, 544), [
                                            [_vModelText, userSearchQuery.value]
                                          ]),
                                          (userSearchResults.value.length > 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userSearchResults.value, (user) => {
                                                  return (_openBlock(), _createElementBlock("button", {
                                                    key: user._id || user.id,
                                                    type: "button",
                                                    class: "list-group-item list-group-item-action",
                                                    onClick: ($event: any) => (selectUser(user))
                                                  }, _toDisplayString(user.name) + " (" + _toDisplayString(user.email) + ") ", 9, _hoisted_37))
                                                }), 128))
                                              ]))
                                            : _createCommentVNode("", true),
                                          (assignmentForm.selectedUser)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                                _createElementVNode("span", _hoisted_39, " Selected: " + _toDisplayString(assignmentForm.selectedUser.name), 1)
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : (assignmentForm.scopeType)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                            _createElementVNode("label", _hoisted_41, [
                                              _createTextVNode(_toDisplayString(assignmentForm.scopeType === "MODULE"
                                  ? "Module Key"
                                  : "Role Name") + " ", 1),
                                              _cache[28] || (_cache[28] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                                            ]),
                                            _withDirectives(_createElementVNode("input", {
                                              type: "text",
                                              class: "form-control",
                                              id: "scopeId",
                                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((assignmentForm.scopeId) = $event)),
                                              placeholder: 
                                assignmentForm.scopeType === 'MODULE'
                                  ? 'e.g., customer-service'
                                  : 'e.g., admin'
                              ,
                                              required: ""
                                            }, null, 8, _hoisted_42), [
                                              [_vModelText, assignmentForm.scopeId]
                                            ])
                                          ]))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_43, [
                                      _createElementVNode("button", {
                                        type: "submit",
                                        class: "btn btn-primary w-100",
                                        disabled: isAddingAssignment.value
                                      }, [
                                        (isAddingAssignment.value)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_45, [...(_cache[29] || (_cache[29] = [
                                              _createElementVNode("span", {
                                                class: "spinner-border spinner-border-sm me-1",
                                                role: "status"
                                              }, null, -1),
                                              _createTextVNode(" Adding... ", -1)
                                            ]))]))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_46, [...(_cache[30] || (_cache[30] = [
                                              _createElementVNode("i", { class: "fa fa-plus me-1" }, null, -1),
                                              _createTextVNode(" Add Assignment ", -1)
                                            ]))]))
                                      ], 8, _hoisted_44)
                                    ])
                                  ])
                                ], 32)
                              ])
                            ]),
                            (isLoadingAssignments.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_47, [...(_cache[32] || (_cache[32] = [
                                  _createElementVNode("div", {
                                    class: "spinner-border text-primary",
                                    role: "status"
                                  }, [
                                    _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
                                  ], -1)
                                ]))]))
                              : (assignments.value.length === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_48, [...(_cache[33] || (_cache[33] = [
                                    _createElementVNode("i", { class: "fa fa-info-circle fa-2x text-muted mb-2" }, null, -1),
                                    _createElementVNode("p", { class: "text-muted" }, "No assignments yet", -1)
                                  ]))]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                    _createElementVNode("table", _hoisted_50, [
                                      _cache[35] || (_cache[35] = _createElementVNode("thead", { class: "table-dark" }, [
                                        _createElementVNode("tr", null, [
                                          _createElementVNode("th", null, "Scope Type"),
                                          _createElementVNode("th", null, "Scope ID"),
                                          _createElementVNode("th", null, "Name"),
                                          _createElementVNode("th", null, "Created"),
                                          _createElementVNode("th", { class: "text-end" }, "Actions")
                                        ])
                                      ], -1)),
                                      _createElementVNode("tbody", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(assignments.value, (assignment) => {
                                          return (_openBlock(), _createElementBlock("tr", {
                                            key: assignment._id || assignment.id
                                          }, [
                                            _createElementVNode("td", null, [
                                              _createElementVNode("span", {
                                                class: _normalizeClass([
                                'badge',
                                getScopeTypeBadgeClass(assignment.scopeType),
                              ])
                                              }, _toDisplayString(assignment.scope_type), 3)
                                            ]),
                                            _createElementVNode("td", null, [
                                              _createElementVNode("code", null, _toDisplayString(assignment.scope_id), 1)
                                            ]),
                                            _createElementVNode("td", null, [
                                              (assignment.agent_id?.name)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_51, _toDisplayString(assignment.agent_id?.name), 1))
                                                : (_openBlock(), _createElementBlock("span", _hoisted_52, "—"))
                                            ]),
                                            _createElementVNode("td", null, [
                                              _createElementVNode("small", null, _toDisplayString(formatDate(assignment.created_at)), 1)
                                            ]),
                                            _createElementVNode("td", _hoisted_53, [
                                              _createElementVNode("button", {
                                                onClick: ($event: any) => (confirmDeleteAssignment(assignment)),
                                                class: "btn btn-outline-danger btn-sm",
                                                title: "Delete"
                                              }, [...(_cache[34] || (_cache[34] = [
                                                _createElementVNode("i", { class: "fa fa-trash" }, null, -1)
                                              ]))], 8, _hoisted_54)
                                            ])
                                          ]))
                                        }), 128))
                                      ])
                                    ])
                                  ]))
                          ]))
                        : _createCommentVNode("", true),
                      (activeTab.value === 'test-chat')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                            _createElementVNode("div", _hoisted_56, [
                              _createElementVNode("div", _hoisted_57, [
                                _createElementVNode("div", {
                                  class: "chat-container mb-3",
                                  ref_key: "chatContainerRef",
                                  ref: chatContainerRef
                                }, [
                                  (chatMessages.value.length === 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_58, [...(_cache[36] || (_cache[36] = [
                                        _createElementVNode("i", { class: "fa fa-comments fa-3x mb-3" }, null, -1),
                                        _createElementVNode("p", null, "Start a conversation to test the agent", -1)
                                      ]))]))
                                    : _createCommentVNode("", true),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chatMessages.value, (message, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: index,
                                      class: _normalizeClass([
                            'chat-message',
                            message.role === 'user'
                              ? 'user-message'
                              : 'agent-message',
                          ])
                                    }, [
                                      _createElementVNode("div", _hoisted_59, [
                                        _createElementVNode("strong", null, _toDisplayString(message.role === "user" ? "You" : agent.value.name), 1),
                                        _createElementVNode("small", _hoisted_60, _toDisplayString(formatTime(message.timestamp)), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_61, _toDisplayString(message.content), 1)
                                    ], 2))
                                  }), 128)),
                                  (isSendingMessage.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                        _createElementVNode("div", _hoisted_63, [
                                          _createElementVNode("strong", null, _toDisplayString(agent.value.name), 1)
                                        ]),
                                        _cache[37] || (_cache[37] = _createElementVNode("div", { class: "message-content" }, [
                                          _createElementVNode("span", { class: "spinner-border spinner-border-sm me-2" }),
                                          _createTextVNode(" Thinking... ")
                                        ], -1))
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 512),
                                _createElementVNode("form", {
                                  onSubmit: _withModifiers(handleSendMessage, ["prevent"])
                                }, [
                                  _createElementVNode("div", _hoisted_64, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "text",
                                      class: "form-control",
                                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((chatInput).value = $event)),
                                      placeholder: "Type your message...",
                                      disabled: isSendingMessage.value
                                    }, null, 8, _hoisted_65), [
                                      [_vModelText, chatInput.value]
                                    ]),
                                    _createElementVNode("button", {
                                      class: "btn btn-primary",
                                      type: "submit",
                                      disabled: !chatInput.value.trim() || isSendingMessage.value
                                    }, [...(_cache[38] || (_cache[38] = [
                                      _createElementVNode("i", { class: "fa fa-paper-plane me-1" }, null, -1),
                                      _createTextVNode(" Send ", -1)
                                    ]))], 8, _hoisted_66),
                                    _createElementVNode("button", {
                                      onClick: clearChat,
                                      class: "btn btn-secondary btn-sm ms-2",
                                      disabled: chatMessages.value.length === 0
                                    }, [...(_cache[39] || (_cache[39] = [
                                      _createElementVNode("i", { class: "fa fa-trash me-1" }, null, -1),
                                      _createTextVNode(" Clear Chat ", -1)
                                    ]))], 8, _hoisted_67)
                                  ])
                                ], 32)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_68, [
              _cache[41] || (_cache[41] = _createElementVNode("i", { class: "fa fa-exclamation-triangle fa-3x text-danger mb-3" }, null, -1)),
              _cache[42] || (_cache[42] = _createElementVNode("p", { class: "text-danger" }, "Failed to load agent details", -1)),
              _createVNode(_component_router_link, {
                to: "/admin/agents",
                class: "btn btn-primary"
              }, {
                default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                  _createTextVNode(" Back to Agents ", -1)
                ]))]),
                _: 1
              })
            ]))
    ]),
    _createElementVNode("div", {
      class: "modal fade",
      id: "deleteAssignmentModal",
      tabindex: "-1",
      ref_key: "deleteAssignmentModalRef",
      ref: deleteAssignmentModalRef
    }, [
      _createElementVNode("div", _hoisted_69, [
        _createElementVNode("div", _hoisted_70, [
          _cache[50] || (_cache[50] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h5", { class: "modal-title" }, "Confirm Delete"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_71, [
            _cache[46] || (_cache[46] = _createElementVNode("p", null, "Are you sure you want to delete this assignment?", -1)),
            _createElementVNode("p", _hoisted_72, [
              _cache[43] || (_cache[43] = _createElementVNode("strong", null, "Scope Type:", -1)),
              _createTextVNode(" " + _toDisplayString(assignmentToDelete.value?.scopeType), 1),
              _cache[44] || (_cache[44] = _createElementVNode("br", null, null, -1)),
              _cache[45] || (_cache[45] = _createElementVNode("strong", null, "Scope ID:", -1)),
              _createTextVNode(" " + _toDisplayString(assignmentToDelete.value?.scopeId), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_73, [
            _cache[49] || (_cache[49] = _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal"
            }, " Cancel ", -1)),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-danger",
              onClick: deleteAssignment,
              disabled: isDeletingAssignment.value
            }, [
              (isDeletingAssignment.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_75, [...(_cache[47] || (_cache[47] = [
                    _createElementVNode("span", {
                      class: "spinner-border spinner-border-sm me-1",
                      role: "status"
                    }, null, -1),
                    _createTextVNode(" Deleting... ", -1)
                  ]))]))
                : (_openBlock(), _createElementBlock("span", _hoisted_76, [...(_cache[48] || (_cache[48] = [
                    _createElementVNode("i", { class: "fa fa-trash me-1" }, null, -1),
                    _createTextVNode(" Delete ", -1)
                  ]))]))
            ], 8, _hoisted_74)
          ])
        ])
      ])
    ], 512)
  ]))
}
}

})